<template>
  <div class="container">
      <section v-if="$route.query.status == 'successful'">
        <article class="payment_page">
            <div>
                <el-result 
                    icon="success" 
                    title="Your Payment has been successful." 
                    subTitle="Your Transaction details have been sent to your email. 
                    Please check your email address.">
                    <!-- <template slot="extra">
                        <el-button type="primary" size="medium">Back</el-button>
                    </template> -->
                </el-result>
            </div>
        </article>
      </section>

      <section v-else-if="$route.query.status == 'cancelled'">
        <article class="payment_page">
            <div>
                <el-result icon="warning"
                    title="Your Payment has been cancelled." 
                    subTitle="Your Transaction has cancelled. Please check out your Balance or try again">
                <!-- <template slot="extra">
                    <el-button type="primary" size="medium">Back</el-button>
                </template> -->
                </el-result>
            </div>
        </article>
      </section>

      <section v-else-if="$route.query.status == 'failed'">
        <article class="payment_page">
            <div>
                <el-result icon="error"
                    title="Your Payment has failed." 
                    subTitle="Your Transaction has failed. Please check out your Balance">
                <!-- <template slot="extra">
                    <el-button type="primary" size="medium">Back</el-button>
                </template> -->
                </el-result>
            </div>
        </article>
      </section>

  </div>
</template>

<script>
    export default {
        data() {
            return {
                value: "",
            }
        },
        

        watch: {
            "$route.query.status": {
                handler: function (status) {
                    this.onQueryChange();
                },
                deep: true,
                immediate: true,
            },
        },

        mounted() {
            this.onQueryChange();
        },

        methods: {
            onQueryChange() {
                if(this.$route.query.status == 'successful') {
                    this.$notify({
                        title: "Success",
                        message: "Transaction Successful.",
                        type: "success",
                    });
                }
                else if(this.$route.query.status == 'cancelled') {
                    this.$notify({
                        title: "Cancelled",
                        message: "Transaction cancelled.",
                        type: "warning",
                    });
                }
                else if(this.$route.query.status == 'failed') {
                    this.$notify({
                        title: "Failed",
                        message: "Transaction failed.",
                        type: "error",
                    });
                }
                else {
                    this.$router.push({path: '/'});
                }
            }
        }
    }
</script>

<style scoped>
    .payment_page {
        height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>